export function scrollToId(id) {
  const target = document.getElementById(id);
  if (!target) return;

  const navbar = document.querySelector('.navbar');
  const navbarBottom = navbar ? navbar.getBoundingClientRect().bottom : 0;

  const cardInner = target.closest('.card-inner');
  if (cardInner) {
    const scrollStart = parseFloat(cardInner.dataset.scrollStart);
    if (!isNaN(scrollStart)) {
      window.scrollTo({ top: scrollStart, behavior: 'smooth' });
      return;
    }
    // Fallback: compute from card index using correct scrollStep formula
    const cardsStack = cardInner.closest('.cards-stack');
    const stackTop = cardsStack
      ? cardsStack.getBoundingClientRect().top + window.pageYOffset
      : 0;
    const index = parseInt(cardInner.style.getPropertyValue('--card-index'), 10) || 0;
    const cardH = window.innerHeight - navbarBottom - 20; // --card-bottom-inset
    const gapPx = 0.4 * window.innerHeight;              // --card-gap: 40dvh
    const top = stackTop + index * (cardH + gapPx);
    window.scrollTo({ top, behavior: 'smooth' });
  } else {
    const top = target.getBoundingClientRect().top + window.pageYOffset - navbarBottom - 16;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}
